import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@material-ui/core';
import { useTranslate, useDataProvider, usePermissions, Loading } from 'react-admin';
import { useHistory, useLocation } from 'react-router-dom';
import Table from '../common/table';
import PageListLabel from '../page-list-label';
import { DeleteOutline, EditOutlined, AssignmentOutlined } from '@material-ui/icons';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import Pagination from '../message/table-pagination';
import { calculateTotalPage } from '../utils';
import DialogListRoom from './dialog-list-room';
import DialogListFirmWare from './dialog-list-firmware';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import RefreshIcon from '@material-ui/icons/Refresh';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import Snackbar from '../common/snackbar';
import DoneIcon from '@material-ui/icons/Done';

const POPUP_KEYS = {
    EDIT: 'EDIT',
    ASSIGN: 'ASSIGN',
    DELETE: 'DELETE',
    UPDATE: 'FIRMWARE UPDATE',
    REBOOT: 'REBOOT',
    TURNOFF: 'TURN OFF',
    NOTIFICATION: 'NOTIFICATION',
    ACTIVATE: 'ACTIVATE'
};

const TYPE_ACTION_KEY = {
    REBOOT: 'REBOOT',
    TURNOFF: 'TURNOFF',
    MESSAGE: 'MESSAGE',
    UPDATE: 'UPDATE',
    ACTIVATE: 'ACTIVATE'

}

const config = {
    headers: [
        { field: 'name', label: 'pos.devices.name', width: 2, bold: true },
        { field: 'ipAddress', label: 'pos.devices.ipAddress', width: 1 },
        { field: 'id', label: 'pos.devices.macAddress', width: 1 },
        { field: 'tvModel', label: 'pos.devices.model', width: 1 },
        { field: 'serialNumber', label: 'pos.devices.serialNumber', width: 1 },
        { field: 'firmware', label: 'Firmware', width: 1 },
        { field: 'Cluster', label: 'pos.devices.roomCluser', width: 1 },
        { field: 'roomID', label: 'pos.devices.roomID', width: 1 },
        { field: 'room', label: 'pos.devices.roomName', width: 1 },
        { field: 'status', label: 'pos.devices.status', width: 1, configColor: true, hiddenSort: true },
    ],
    popupBodies: [
        { id: POPUP_KEYS.EDIT, label: 'pos.common.edit', icon: EditOutlined, hidden: true },
        { id: POPUP_KEYS.ASSIGN, label: 'pos.devices.assignToRoom', icon: AssignmentOutlined, hidden: true },
        { id: POPUP_KEYS.DELETE, label: 'pos.common.delete', icon: DeleteOutline, isDelete: true, hidden: true },
        { id: POPUP_KEYS.UPDATE, label: 'pos.devices.firmwareUpdate', icon: SystemUpdateAltIcon, hidden: true },
        { id: POPUP_KEYS.REBOOT, label: 'pos.devices.reboot', icon: RefreshIcon, hidden: true },
        { id: POPUP_KEYS.TURNOFF, label: 'pos.devices.turnOff', icon: PowerSettingsNewIcon, hidden: true },
        { id: POPUP_KEYS.NOTIFICATION, label: 'pos.devices.notification', icon: NotificationsActiveIcon, hidden: true },
        { id: POPUP_KEYS.ACTIVATE, label: 'pos.devices.activate', icon: DoneIcon, hidden: true },
    ]
}

const configClusterMode = {
    headers: config.headers,
    popupBodies: [
        { id: POPUP_KEYS.UPDATE, label: 'pos.devices.firmwareUpdate', icon: SystemUpdateAltIcon, hidden: true }
    ]
}
let _intervalUpdateStatus = null;

export default function DeviceProfiles(props) {
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const { permissions, loaded } = usePermissions();
    const history = useHistory();
    const location = useLocation();

    // STATES
    const [search, setSearchText] = useState('');
    const [ShowSnackbarAssign, setShowSnackbarAssign] = useState(false);
    const [loading, setLoading] = useState(false);
    const [pages, setPages] = useState([]);
    const [totalDevice, setTotalDevice] = useState(0);
    const [pagination, setPagination] = useState({
        page: 1,
        perPage: 10
    });
    const [device, setDevice] = useState({
        bodies: [],
        sortable: { field: 'name', order: 'ASC' },
    });
    const [dialogAssignment, setDialogAssignment] = useState({
        open: false,
        listDevices: []
    });
    const [dialogFirmWare, setDialogFirmWare] = useState({
        open: false,
        listDevices: []
    });
    const [randomNumber, setRandomNumber] = useState(Math.random());
    const [clusterMode] = useState(props.selectedClusterData ? true : false);
    // END STATES

    const getListDevices = () => {
        setLoading(true);
        let filter = {
            search: search.trim()
        }
        if (clusterMode) {
            filter.clusterId = props.selectedClusterData.id;
        }

        if (location.state)
            filter.profile = location.state
        dataProvider('GET_LIST', "devices", {
            filter,
            pagination: search === '' ? pagination : {
                page: pagination.page,
                perPage: 10
            },
            sort: device.sortable
        }).then(({ data, total }) => {
            // console.log('Get list success:', data);
            let devices = data.map(item => ({
                ...item,
                checked: false,
                status: item.status === 1 ? translate(`pos.common.online`) : translate(`pos.dashboard.offline`),
                green: item.status,
                red: !item.status,
                // room: item.roomCluster
            }));
            setDevice({
                ...device,
                bodies: devices
            });
            setPages(calculateTotalPage(total, pagination.perPage));
            setTotalDevice(total)
        }).catch(error => {
            console.error('Get list error:', error);
        }).finally(() => setLoading(clusterMode));
    }

    const getStatus = () => {
        if (device.bodies) {
            const temps = device.bodies.slice();
            const arrayMac = [];
            device.bodies.forEach((value) => {
                arrayMac.push(value.id)
            });

            if (arrayMac.length > 0) {
                dataProvider('CREATE', "devices/getstatus", {
                    data: {
                        macs: arrayMac
                    }
                }).then(({ data }) => {
                    data.forEach((item, index) => {
                        if (!item.status || item.status === 1) {
                            temps[index].status = translate(`pos.dashboard.offline`)
                            temps[index].red = true;
                            temps[index].green = false;
                        } else {
                            temps[index].status = translate(`pos.common.online`)
                            temps[index].red = false;
                            temps[index].green = true;
                        }
                    });
                    // setDevice({
                    //     // ...device,
                    //     bodies: temps
                    // });
                });
            }
        }
    }

    const onCheck = (checkedItem) => {
        const newLists = device.bodies.map((item) => ({
            ...item,
            checked: item.id === checkedItem.id ? !item.checked : item.checked
        }));

        setDevice({
            ...device,
            bodies: newLists
        });
    }

    const onCheckAll = (isCheckedAll) => {
        const newLists = device.bodies.map(item => ({
            ...item,
            checked: !isCheckedAll
        }));
        setDevice({
            ...device,
            bodies: newLists
        });
    }

    const onSort = (sortable) => {
        setDevice({
            ...device,
            sortable
        });
    }
    const onActionClick = (id, key) => {
        dataProvider('CREATE', "rebootDevices", {
            data: {
                key: key.toLowerCase(),
                deviceId: id
            }
        }).then(({ data }) => {
            console.log('send socket success:', data);
        }).catch(error => {
            console.error('send socket error:', error);
        })
    }


    const onActionMenuClick = (item, actionId) => {

        switch (actionId) {
            case POPUP_KEYS.EDIT:
                history.push('/ClientDevice/' + item.id);
                break;
            case POPUP_KEYS.ASSIGN:
                onOpenAssignment([item]);
                break;
            case POPUP_KEYS.UPDATE:
                onOpenFirmWare([item])
                break;
            case POPUP_KEYS.REBOOT:
                onActionClick(item.id, TYPE_ACTION_KEY.REBOOT)
                break;
            case POPUP_KEYS.TURNOFF:
                onActionClick(item.id, TYPE_ACTION_KEY.TURNOFF)
                break;
            case POPUP_KEYS.NOTIFICATION:
                onActionClick(item.id, TYPE_ACTION_KEY.MESSAGE)
                break;
            case POPUP_KEYS.ACTIVATE:
                onActionClick(item.id, TYPE_ACTION_KEY.ACTIVATE)
                break;

            default:
                break;
        }
    }
    const onUpdateFirmware = () => {
        // map array ID Device
        const listDevices = device.bodies.filter(item => item.checked);
        onOpenFirmWare(listDevices)
    }
    const onAssignMulti = () => {
        const listDevices = device.bodies.filter(item => item.checked);
        onOpenAssignment(listDevices);
    }

    const onOpenAssignment = (listDevices) => {
        setDialogAssignment({
            open: true,
            listDevices
        });
    }
    const onOpenFirmWare = (listDevices) => {
        setDialogFirmWare({
            open: true,
            listDevices
        });
    }

    const onChangePage = (nextPage) => {
        if (nextPage !== pagination.page) {
            setPagination({
                page: nextPage,
                perPage: pagination.perPage
            });
        }
    }

    const onPreviousPage = () => {
        const { page } = pagination;
        if (page > 1) {
            onChangePage(page - 1);
        }
    }

    const onNextPage = () => {
        const { page } = pagination;
        if (page < pages.length) {
            onChangePage(page + 1);
        }
    }

    const onCloseDialogAssign = () => {
        setDialogAssignment({
            open: false,
            listDevices: []
        });
    }
    const onCloseDialogFirmWare = () => {
        setDialogFirmWare({
            open: false,
            listDevices: []
        });
    }

    useEffect(() => {
        getListDevices();
        setRandomNumber(Math.random());
    }, [pagination.page, device.sortable]);

    useEffect(() => {
        getStatus();
        if (clusterMode) {
            const onlinedevices = device.bodies.filter(d => d.status === translate(`pos.common.online`));
            setDevice({ bodies: onlinedevices, sortable: device.sortable });
            setTotalDevice(onlinedevices.length);
            setPages([1]);
            setLoading(false);
        }
    }, [randomNumber]);

    useEffect(() => {
        getStatus();
        if (!_intervalUpdateStatus)
            _intervalUpdateStatus = setInterval(() => {
                setRandomNumber(Math.random());
            }, 5000);
        return () => {
            if (_intervalUpdateStatus) {
                clearInterval(_intervalUpdateStatus);
                _intervalUpdateStatus = null;
            }
        };
    }, [device]);
    useEffect(() => {
        if (ShowSnackbarAssign) {
            setTimeout(() => {
                setShowSnackbarAssign(false);
            }, 6000);
        }
    }, [ShowSnackbarAssign]);

    if (!loaded) return <Loading />;
    config.popupBodies.map(item => {
        item.hidden = !permissions.functionAction.find((value) => value.function === 'Client devices' && value.isUpdate)
    })

    configClusterMode.popupBodies.map(item => {
        item.hidden = !permissions.functionAction.find((value) => value.function === 'Client devices' && value.isUpdate)
    })

    if (device.bodies && device.bodies.length < 0) return <Loading />
    return (
        <Box mt={5} py={2} width="95%" m='auto' style={{ marginTop: clusterMode ? "-50px" : "" }}>
            <PageListLabel
                label={translate('pos.devices.titleDevices')}
                buttonHidden={true}
                searchPlaceholder={translate('pos.devices.search')}
                onChangeText={setSearchText}
                getList={getListDevices}
                total={totalDevice}
            />
            <Snackbar
                show={ShowSnackbarAssign}
                message={translate('pos.devices.SnackbarAssign')}
                onClose={() => setShowSnackbarAssign(false)}
            />
            <Table
                config={clusterMode ? configClusterMode : config}
                selectedClusterData={props.selectedClusterData}
                clusterMode={clusterMode}
                data={device}
                loading={loading}
                onCheck={onCheck}
                onCheckAll={onCheckAll}
                onSort={onSort}
                onAction={onActionMenuClick}
                isDevice={true}
                path={'ClientDevice'}
                tableDelete={{
                    getList: getListDevices,
                    setList: setDevice,
                    urlDelete: 'device'
                }}
                headerButtons={!clusterMode ? [
                    { id: '1', label: translate('pos.categories.Delete'), icon: <DeleteOutline />, isDelete: true },
                    { id: '2', label: translate('pos.devices.assign'), icon: <AssignmentOutlined />, action: onAssignMulti },
                    { id: '3', label: translate('pos.devices.firmwareUpdate'), icon: <SystemUpdateAltIcon />, action: onUpdateFirmware },
                ] : [
                    { id: '3', label: translate('pos.devices.firmwareUpdate'), icon: <SystemUpdateAltIcon />, action: onUpdateFirmware },
                ]}
                noDataLabel={translate('pos.devices.noData')}
            />
            {
                !clusterMode && <Pagination
                    pages={pages}
                    currentPage={pagination.page}
                    onChangePage={onChangePage}
                    onPrevious={onPreviousPage}
                    onNext={onNextPage}
                />
            }
            {
                !clusterMode && <DialogListRoom
                    open={dialogAssignment.open}
                    onClose={onCloseDialogAssign}
                    listDevices={dialogAssignment.listDevices}
                    getListDevices={getListDevices}
                    setShowSnackbarAssign={setShowSnackbarAssign}
                />
            }
            <DialogListFirmWare
                open={dialogFirmWare.open}
                onClose={onCloseDialogFirmWare}
                listDevices={dialogFirmWare.listDevices}
                getListDevices={getListDevices}
            />
        </Box>
    )
}
